import Vue from 'vue'

import wx from "jweixin-1.6.0";

export const config = async (_this) => {
    let jsApiList = [
        "checkJsApi",
        "onMenuShareTimeline",
        "onMenuShareAppMessage",
        "updateAppMessageShareData",
        "updateTimelineShareData",
    ];
    var localUrl = 'https://wxoffih5.siguilew.com/cishanzhixing/';
    let response = await _this.$api.getShareConfig(localUrl);
    if (response && response.success) {
        const { appId, nonceStr, signature, timestamp } = response.data;
        //通过微信config接口注入配置
        wx.config({
            debug: false, //默认为false 为true的时候是调试模式，会打印出日志
            appId: appId,
            timestamp: timestamp,
            nonceStr: nonceStr,
            signature: signature,
            jsApiList: jsApiList,
        });
        // config
        wx.ready(function () {
            let shareData = {
                title: `第十一届上海市慈善之星选树活动入围对象优秀事迹展示`, // 这是分享展示卡片的标题
                desc: `快来参与点亮吧~`, // 这是分享展示的摘要
                link: localUrl, // 这里是分享的网址
                imgUrl:
                    "https://wxoffih5.siguilew.com/cishanzhixing/static/img/sharebg.png", // 这里是需要展示的图标
                success: function (rr) {
                    console.log("成功" + JSON.stringify(rr));
                },
                cancel: function (tt) {
                    console.log("失败" + JSON.stringify(tt));
                },
            };
            wx.checkJsApi({
                jsApiList: jsApiList,
                success: function (res) {
                    try {
                        // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
                        if (res.checkResult.updateAppMessageShareData) {
                            wx.updateAppMessageShareData(shareData);
                        }
                    } catch (ex) {
                        console.log("updateAppMessageShareDataErr", ex);
                    }
                    try {
                        // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
                        if (res.checkResult.updateTimelineShareData) {
                            wx.updateTimelineShareData(shareData);
                        }
                    } catch (ex) {
                        console.log("updateTimelineShareDataErr", ex);
                    }
                    try {
                        // 获取“分享给朋友”按钮点击状态及自定义分享内容接口（即将废弃）
                        if (res.checkResult.onMenuShareAppMessage) {
                            wx.onMenuShareAppMessage(shareData);
                        }
                    } catch (ex) {
                        console.log("onMenuShareAppMessageErr", ex);
                    }
                    try {
                        // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
                        if (res.checkResult.onMenuShareTimeline) {
                            wx.onMenuShareTimeline(shareData);
                        }
                    } catch (ex) {
                        console.log("onMenuShareTimelineErr", ex);
                    }
                },
            });
        });
        wx.error(function (res) {
            console.log("error", res);
        });
    } else {
        _this.$toast("获取分享参数失败");
    }
    _this.$toast.clear();
}


// WEBPACK FOOTER //
// ./src/utils/wxShare.js